var exports = {
  "I": "x127c5a35--578c23--empty",
};

module.exports = exports;
